import React from 'react';
import Text from '@/components/Typography/Text';
import { useTheme } from '@/context/ThemeContext';

// Sites uses the neutral brand palette, including when the surrounding app
// still has a legacy tinted theme. Preserve the user's light/dark appearance.
const LIGHT = { solid_color_primary: '#FFFFFF', solid_color_secondary: '#F5F5F5', text_color_primary: '#040404', text_color_secondary: '#616161', border_color_secondary: '#E5E5E5' };
const DARK = { solid_color_primary: '#040404', solid_color_secondary: '#1C1C1C', text_color_primary: '#FFFFFF', text_color_secondary: '#B3B3B3', border_color_secondary: '#383838' };
export function useSiteColors() {
  const { colors } = useTheme();
  return colors.status_bar_style === 'light' ? DARK : LIGHT;
}
export function SiteText({ color, style, ...props }) {
  const colors = useSiteColors();
  return <Text {...props} style={[{ color: color === 'secondary' ? colors.text_color_secondary : colors.text_color_primary }, style]} />;
}
